/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Compact row for Cloudflare upload field items
 */
import _ from 'lodash';
import { Button, Progress, Typography } from 'antd';
import { Delete } from '@icon-park/react';

const uploadItemStyle: React.CSSProperties = {
	padding: '6px 10px',
	border: '1px solid #f0f0f0',
	borderRadius: 6,
	background: '#fcfcfc',
};

const uploadItemHeaderStyle: React.CSSProperties = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: 8,
};

type CloudflareUploadFieldRowProps = {
	name: string;
	meta?: string;
	progress?: number;
	status?: 'active' | 'exception';
	statusText?: string;
	statusType?: 'secondary' | 'danger';
	onRemove?: () => void;
	disabled?: boolean;
};

const CloudflareUploadFieldRow: React.FC<CloudflareUploadFieldRowProps> = ({
	name,
	meta,
	progress,
	status,
	statusText,
	statusType = 'secondary',
	onRemove,
	disabled,
}) => (
	<div style={uploadItemStyle}>
		<div style={uploadItemHeaderStyle}>
			<Typography.Text ellipsis style={{ flex: 1, minWidth: 0, fontSize: 12, lineHeight: '16px' }}>
				{name}
			</Typography.Text>
			{onRemove && (
				<Button type='text' icon={<Delete style={{ color: 'red' }} />} size='small' onClick={onRemove} disabled={disabled} />
			)}
			{!onRemove && meta && (
				<Typography.Text type='secondary' style={{ fontSize: 11, lineHeight: '16px' }}>
					{meta}
				</Typography.Text>
			)}
		</div>
		{_.isNumber(progress) && (
			<Progress percent={progress} size='small' status={status} showInfo={false} style={{ margin: '4px 0 0' }} />
		)}
		{statusText && (
			<Typography.Text type={statusType} style={{ display: 'block', marginTop: 2, fontSize: 11, lineHeight: '16px' }}>
				{statusText}
			</Typography.Text>
		)}
	</div>
);

export default CloudflareUploadFieldRow;
